import { useMemo, useState } from 'react'
import {
  filterMarketplaceApps,
  getAllMarketplaceApps,
  getPopularMarketplaceApps,
} from '@/data/integrationsMarketplace/integrationsMarketplaceCatalog.js'

export function useIntegrationsMarketplaceModel() {
  const [categoryId, setCategoryId] = useState('all')
  const [query, setQuery] = useState('')

  const allApps = useMemo(() => getAllMarketplaceApps(), [])

  const filteredApps = useMemo(
    () =>
      filterMarketplaceApps(allApps, {
        categoryId,
        query,
      }),
    [allApps, categoryId, query],
  )

  const popularApps = useMemo(() => getPopularMarketplaceApps(allApps), [allApps])

  const showPopularSection = categoryId === 'all' && !query.trim()

  const gridApps = showPopularSection ? popularApps : filteredApps

  return {
    categoryId,
    setCategoryId,
    query,
    setQuery,
    filteredApps,
    gridApps,
    showPopularSection,
    visibleCount: filteredApps.length,
    totalCount: allApps.length,
  }
}
